export default {
  CATALOG: 'catalog',
  SALE_PORTAL_BFF: window.APP_CODE ? window.APP_CODE : 'dgl:sale-portal-bff',
  TIMESHEET_BFF: 'dgl:dgl-timesheet-bff',
  ATTRIBUTE_PROMO: 'Promo',
  TICKET_BFF_SERVICE: 'dgl:ticket-bff',
  LEAD_BFF: 'teko-lm-bff-v2',
};
